module.exports = __webpack_public_path__ + "img/5.76e95f58.jpg";